export enum ManualPaymentStepEnum {
    PaymentDetails = 'Payment details',
    Product = 'Payment products'
}